import { CopyPricePeriod } from '@features/TimberBuyer/SalesAgreements/PricePeriods/Copy/CopyPricePeriod'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'
import { z } from 'zod'

const copyPricePeriodSearchSchema = z.object({
  sourcePricePeriodId: z.string().optional(),
})

const CopyPricePeriodRoute: React.FC = () => {
  const { timberBuyerId, salesAgreementId } = Route.useParams()
  const { sourcePricePeriodId } = Route.useSearch()

  return (
    <CopyPricePeriod
      timberBuyerId={timberBuyerId}
      salesAgreementId={salesAgreementId}
      sourcePricePeriodId={sourcePricePeriodId}
    />
  )
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/price-periods/copy/',
)({
  component: CopyPricePeriodRoute,
  validateSearch: copyPricePeriodSearchSchema,
  staticData: {
    breadcrumb: t('timberbuyer-salesagreements-priceperiods.copyPage.breadcrumb'),
  },
})
